import React , { Component } from "react";
import { connect } from 'react-redux';
import { currentWidget, setPreloadScreen } from '../../../action/action';
import { setAdminLoginPage } from "../../action/homeAction";
import $ from 'jquery'
// import { serviceUnavailable } from '../../../reducers/layout2Reducer'
import {withTranslation} from "react-i18next";

class NoConnection extends Component{


    constructor(props){
        super(props)
        this.state = {
            message: '',
            logoClickCount: 0
        }
        this.logoClickTimeOut = null
    }

    handleOpenAdminPage = (e) => {
        window.clearTimeout(this.logoClickTimeOut);
        if (this.state.logoClickCount >= 5) {
            this.props.setAdminLoginPage(true);
        } else {
            this.setState({ logoClickCount: this.state.logoClickCount + 1 })
        }
        this.logoClickTimeOut = window.setTimeout(
            () => { this.setState({ logoClickCount: 0 }) }, 2000
        )
    }

    componentWillUnmount(){
        this.props.currentWidget({});
        $("#app-body").css("background","transparent");
    }

    componentDidMount(){
        this.props.setPreloadScreen(false)
        this.props.currentWidget({widgetType: true});
        $("#app-body").css("background","#fff");
        $("body").css("background","#fff");

        if(this.props.location){
            let message = new URLSearchParams(this.props.location.search).get("msg")
            this.setState({message:message})
        }

        if(this.props.message){
            this.setState({message:this.props.message})
        }

        if(window && window.FirebasePlugin) window.FirebasePlugin.stopTrace("App_Load_failed");
        if(window.FirebasePlugin  ) window.FirebasePlugin.setCrashlyticsCustomKey('App_Load_failed', "" );

    }

    clickReload = () => {
        this.props.setPreloadScreen(true)
        window.location.reload()
    }


    render(){
        console.log('this.props.serviceUnavailable',this.props.serviceUnavailable, navigator.onLine &&  this.props.serviceUnavailable)
        const { t } = this.props
        console.log('message', this.state.message)
        return(
            navigator.onLine &&  this.props.serviceUnavailable || this.props.error?
                <div style = {{maxHeight:'100vh',background: "transparent"}}>
                    <header>
                        <div class="hotel-name"></div>
                        <div class="guest-photo" style={{display: 'none'}}></div>
                        <div style={{color: "#000"}} onClick={this.handleOpenAdminPage}>
                            <h1>{t('service_unavailable.title')}</h1>
                        </div>
                    </header>
                    <section id="landingPage" class="widgets">
                        <div class="offline unavailable">
                            <h2 style={{textAlign: 'center'}}>{ this.state.message ? this.state.message : t('service_unavailable.title_texts')}</h2>
                            <p style={{textAlign: 'center'}}>{t('service_unavailable.retry_fraction1')} <a onClick = {this.clickReload}><strong>{t('service_unavailable.retry_fraction2')}</strong></a> {t('service_unavailable.retry_fraction3')}</p>
                        </div>
                    </section>

                    <footer>
                        <div className="nav">
                            <a className="button" style = {{padding:"0 1.25rem",background:"#fff",boxShadow:"unset"}}>
                                <span className="button-icon" >
                                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.66 55.45">
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M75.15,31.8h0l-.1-.17a18.07,18.07,0,0,0-1.34-2.35l-13.17-23h0A11,11,0,0,0,40.19,7.67H36.47A11,11,0,0,0,16.1,6.23h0L2.93,29.28a17.15,17.15,0,0,0-1.35,2.36l-.09.16h0A16.73,16.73,0,0,0,30.58,48.13h15.5A16.73,16.73,0,0,0,75.15,31.8ZM18.06,50.05A12.89,12.89,0,1,1,30.94,37.16,12.89,12.89,0,0,1,18.06,50.05Zm42,0A12.89,12.89,0,1,1,72.9,37.16,12.89,12.89,0,0,1,60,50.05Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                <span className="button-label">{t('service_unavailable.explore')}</span>
                            </a>
                            <a className="button" style = {{padding:"0 1.25rem",background:"#fff",boxShadow:"unset"}}>
                                <span className="button-icon" >
                                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.15 47.25">
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M8.59,13.81a6,6,0,0,1,6-6h18a6,6,0,0,1,6,6,6,6,0,0,1,6-6h18a6,6,0,0,1,6,6v1.82h2.11V7a7,7,0,0,0-7-7H13.48a7,7,0,0,0-7,7v8.63H8.59Z"/>
                                                <path d="M16.22,10.17a4.49,4.49,0,0,0-4.48,4.49v1h24v-1a4.49,4.49,0,0,0-4.49-4.49Z"/>
                                                <path d="M46.22,10.21a4.49,4.49,0,0,0-4.49,4.49v1h24v-1a4.49,4.49,0,0,0-4.48-4.49Z"/>
                                                <path d="M73.15,18.44H4a4,4,0,0,0-4,4V37.53a4,4,0,0,0,3.66,4l-1.13,4s-.15,2.78,2.74,1.39l3.46-5.33H68.42l3.46,5.33c2.88,1.39,2.74-1.39,2.74-1.39l-1.14-4a4,4,0,0,0,3.67-4V22.44A4,4,0,0,0,73.15,18.44Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                <span className="button-label">{t('service_unavailable.my_stay')}</span>
                            </a>
                            <a className="button" style = {{padding:"0 1.25rem",background:"#fff",boxShadow:"unset"}}>
                                <span className="button-icon" >
                                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.11 65.51">
                                        <title>ico_notify</title>
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M50.93,49.18c-3.57-2.44-4.51-10.7-4.51-10.7V24.4C45.09,14.21,37,9.91,31.4,8.13V5.35a5.35,5.35,0,1,0-10.7,0V8.13C15.13,9.91,7,14.21,5.69,24.4V38.48s-.94,8.26-4.51,10.7,2.07,6.38,2.07,6.38a121.78,121.78,0,0,0,15.92,3.87,6.94,6.94,0,0,0,13.77,0,121.78,121.78,0,0,0,15.92-3.87S54.49,51.62,50.93,49.18Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                <span className="button-label">{t('service_unavailable.notification')}</span>
                            </a>
                        </div>
                    </footer>
                    
                    <script type="text/javascript" src="js/jquery-3.3.1.min.js"></script>
                    <script type="text/javascript" src="js/framework.js"></script>
                    <script src="js/swiper.js"></script>
                </div>
            :
                <div style = {{maxHeight:'100vh',background: "transparent"}}>
                    <header>
                        <div className="hotel-name"></div>
                        <div className="guest-photo" style={{display: "none"}}></div>
                        <div style = {{color:"#222"}}>
                            <h1>{t('no_connection.title')}</h1>
                        </div>
                    </header>
                    <section id="landingPage" className="widgets">
                        <div className="offline">
                            <h2 style = {{lineHeight:"45px"}}>{t('no_connection.title_texts')} <span style = {{color:"#0645AD", textDecoration:"underline"}} onClick = {this.clickReload}>{t('no_connection.try_again')}</span></h2>
                            <p>{t('no_connection.footer')}</p>
                        </div>
                    </section>
    
                    <footer>
                        <div className="nav">
                            <a className="button" style = {{padding:"0 1.25rem",background:"#fff",boxShadow:"unset"}}>
                                <span className="button-icon" >
                                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.66 55.45">
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M75.15,31.8h0l-.1-.17a18.07,18.07,0,0,0-1.34-2.35l-13.17-23h0A11,11,0,0,0,40.19,7.67H36.47A11,11,0,0,0,16.1,6.23h0L2.93,29.28a17.15,17.15,0,0,0-1.35,2.36l-.09.16h0A16.73,16.73,0,0,0,30.58,48.13h15.5A16.73,16.73,0,0,0,75.15,31.8ZM18.06,50.05A12.89,12.89,0,1,1,30.94,37.16,12.89,12.89,0,0,1,18.06,50.05Zm42,0A12.89,12.89,0,1,1,72.9,37.16,12.89,12.89,0,0,1,60,50.05Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                <span className="button-label">{t('service_unavailable.explore')}</span>
                            </a>
                            <a className="button" style = {{padding:"0 1.25rem",background:"#fff",boxShadow:"unset"}}>
                                <span className="button-icon" >
                                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.15 47.25">
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M8.59,13.81a6,6,0,0,1,6-6h18a6,6,0,0,1,6,6,6,6,0,0,1,6-6h18a6,6,0,0,1,6,6v1.82h2.11V7a7,7,0,0,0-7-7H13.48a7,7,0,0,0-7,7v8.63H8.59Z"/>
                                                <path d="M16.22,10.17a4.49,4.49,0,0,0-4.48,4.49v1h24v-1a4.49,4.49,0,0,0-4.49-4.49Z"/>
                                                <path d="M46.22,10.21a4.49,4.49,0,0,0-4.49,4.49v1h24v-1a4.49,4.49,0,0,0-4.48-4.49Z"/>
                                                <path d="M73.15,18.44H4a4,4,0,0,0-4,4V37.53a4,4,0,0,0,3.66,4l-1.13,4s-.15,2.78,2.74,1.39l3.46-5.33H68.42l3.46,5.33c2.88,1.39,2.74-1.39,2.74-1.39l-1.14-4a4,4,0,0,0,3.67-4V22.44A4,4,0,0,0,73.15,18.44Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                <span className="button-label">{t('service_unavailable.my_stay')}</span>
                            </a>
                            <a className="button" style = {{padding:"0 1.25rem",background:"#fff",boxShadow:"unset"}}>
                                <span className="button-icon" >
                                    <svg className="svgColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.11 65.51">
                                        <title>ico_notify</title>
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M50.93,49.18c-3.57-2.44-4.51-10.7-4.51-10.7V24.4C45.09,14.21,37,9.91,31.4,8.13V5.35a5.35,5.35,0,1,0-10.7,0V8.13C15.13,9.91,7,14.21,5.69,24.4V38.48s-.94,8.26-4.51,10.7,2.07,6.38,2.07,6.38a121.78,121.78,0,0,0,15.92,3.87,6.94,6.94,0,0,0,13.77,0,121.78,121.78,0,0,0,15.92-3.87S54.49,51.62,50.93,49.18Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                                <span className="button-label">{t('service_unavailable.notification')}</span>
                            </a>
                        </div>
                    </footer>
                </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        serviceUnavailable : state.store2.serviceUnavailable,
        menuColor: state.store.home.MenuColor,
    }
}

export default connect(mapStateToProps, { currentWidget, setPreloadScreen, setAdminLoginPage })(withTranslation('translations')(NoConnection));